import { Button, Modal, message } from "antd"
import React, { useState } from "react"
import sponsoredProductsApi from "../../../api-wrapper/sponsoredProducts/sponsoredProductsApi"
import { IHistory } from "../store/types/manyTargetCampaignsHistory"
import { IChangedTarget } from "../../../types/target"
import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"

interface ReverseChangesProps {
  selectedRowId: string[]
  history: IHistory[]
}

const ReverseChanges: React.FC<ReverseChangesProps> = ({ selectedRowId, history }) => {
  const [isReversing, setIsReversing] = useState(false)
  const { fetchHistory } = useActions()
  const { dateRange } = useTypedSelector((state) => state.filter)

  async function reverseChange() {
    const selectedTargets = history.filter((item) => selectedRowId.includes(item._id))
    const targetForReverse: IChangedTarget[] = selectedTargets.map((target) => {
      return {
        targetId: target.targetId,
        oldBid: target.newBid,
        newBid: target.oldBid,
        targetType: target.targetType,
      }
    })

    setIsReversing(true)
    try {
      await sponsoredProductsApi.applyOnAmazon({
        cangedTargets: targetForReverse,
      })
      message.success("Changes reversed")
      fetchHistory(dateRange)
    } catch (_e) {
      message.error("Failed to reverse changes")
    } finally {
      setIsReversing(false)
    }
  }

  function confirmReverseChange() {
    Modal.confirm({
      title: "Reverse changes",
      content: `Reverse all ${selectedRowId.length} completed SP bid change(s) in the selected date range?`,
      okText: "Reverse",
      onOk: reverseChange,
    })
  }

  return (
    <Button
      onClick={confirmReverseChange}
      loading={isReversing}
      disabled={selectedRowId.length === 0}
    >
      Reverse changes
    </Button>
  )
}

export default ReverseChanges
